/* global API_ROOT */
 
import { artistsFetch, artistFetch, clearArtist } from './'
import { tutorialsFetch } from '../tutorials'
import { webinarsFetch } from '../webinars'
import { blogPostsFetch } from '../blogPosts'
import { assetsFetch } from '../assets'

export const artistsMergeProps = (stateProps, dispatchProps, ownProps) => {
  const { dispatch } = dispatchProps
  return {
    ...stateProps,
    ...ownProps,
    loadArtists(filters) {
      dispatch(artistsFetch(filters)())
    }
  }
}

export const artistDispatchers = (dispatch, props) => ({
  loadArtistInfo() {
    dispatch(artistFetch(props.params.artistSlug)()).then(([_, res]) => {
      dispatch(blogPostsFetch({ author: res.payload.user })())
      dispatch(assetsFetch('artist', res.payload.id, 50)())
    })
  },
  loadArtistTutorials() {
    // SPEC-129: the page renders the whole list, so ask for all of it
    // (the API's default page is 12 and it clamps limit at 200)
    dispatch(tutorialsFetch({ artist: props.params.artistSlug, limit: 100 })())
  },
  loadArtistWebinars() {
    dispatch(webinarsFetch({ artist: props.params.artistSlug })())
  },
  clearArtist() {
    dispatch(clearArtist())
  }
})
